import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const actionButtonDict = {
  0: {
    consultant: 'Log time',
    employer: 'Time track',
  },
  1: {
    consultant: 'Submit',
    employer: 'Approve',
  },
  2: {
    consultant: 'Export',
    employer: 'Invite',
  },
  3: {
    consultant: 'Ready',
    employer: 'Ready',
  },
};

const progressEllipses = (sequence, setSequence) => {
  const elements = [];
  for (let i = 0; i < 4; i += 1) {
    elements.push(
      <i
        key={i}
        className={`${sequence === i ? 'fas' : 'far'} fa-circle`}
        role="link"
        tabIndex={0}
        onClick={() => setSequence(i)}
      />,
    );
  }
  return elements;
};

const renderForwardStep = (type, sequence) => actionButtonDict[sequence][type];

function InvoicesWalkthroughFooter({
  type, sequence, setSequence, closeModal,
}) {
  return (
    <div className="walthrough-footer">
      <span
        className="backward"
        tabIndex={0}
        role="link"
        onClick={() => {
          if (sequence > 0) setSequence(sequence - 1);
        }}
      >
        {
        sequence > 0 && (
          <Fragment>
            <i className="fas fa-angle-left" />
            Back
          </Fragment>
        )
      }
      </span>
      <span className="progress-ellipses">
        {progressEllipses(sequence, setSequence)}
      </span>
      <span
        className="forward"
        tabIndex={0}
        role="link"
        onClick={() => {
          if (sequence === 3) closeModal();
          setSequence(sequence < 3 ? sequence + 1 : 0);
        }}
      >
        {renderForwardStep(type, sequence)}
        <i className="fas fa-angle-right" />
      </span>
    </div>
  );
}

InvoicesWalkthroughFooter.propTypes = {
  type: PropTypes.string.isRequired,
  sequence: PropTypes.number.isRequired,
  setSequence: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default InvoicesWalkthroughFooter;
